module.exports = __webpack_public_path__ + "img/cancun-bay-pool-5.bfd10a90.jpg";